<template>
  <div
    v-if="front.contactUsOpen"
    class="auth-dialog-backdrop"
    role="dialog"
    aria-modal="true"
    aria-label="联系我们"
    @click.self="front.closeContactUs"
  >
    <article class="auth-dialog contact-us-dialog">
      <div class="auth-dialog-head">
        <h3>联系我们</h3>
        <button type="button" class="text-link" @click="front.closeContactUs">关闭</button>
      </div>
      <div class="auth-dialog-body contact-us-body">
        <div
          v-if="hasContent"
          class="contact-us-html"
          v-html="front.siteConfig.contactUsHtml"
        />
        <p v-else class="contact-us-empty">暂无联系信息</p>
      </div>
    </article>
  </div>
</template>

<script>
export default {
  name: 'ContactUsModal',
  inject: ['front'],
  computed: {
    hasContent() {
      const html = (this.front.siteConfig && this.front.siteConfig.contactUsHtml) || ''
      const plain = String(html)
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .trim()
      return plain.length > 0
    }
  }
}
</script>
